import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
const fb = require('../firebaseConfig.js')

/*
//handle page reload
fb.auth.onAuthStateChanged(user=>{
    if (user){  
        //console.log("state chanaged")
        store.commit('setAuthUser',user)
        //store.dispath('fetchCurrentUser');

        //Create a query snapshot on the userProfile collection for realtime updates
        if (user){
            fb.usersCollection.doc(user.uid).onSnapshot(doc=>{
                store.commit('setCurrentUser',doc.data())
            })
    
        }else{
            console.log("!fb.usersCollection.doc")
        }

    }

})
*/

export const store = new Vuex.Store({
    state:{
        authUser:null,
        currentUser:null,
        users:[],
        userProfile:{},
        brands:[],
        departments:[],
        assignees:[],
        issueMaster:[],
        issueTypes:[],
        issueSubtypes:[],
        issuesBuffer:{
            issues:[],
        },
        issueStatuses:[],
        problemSources:[],
        accountablePersons:[],
        solutions:[],
        solutionTypes:[],
        solutionMethods:[],
        sections:[],
        locations:[],
        diagnostics:[],
        diagnosticTypes:[],
        photos:[],
        documents:[],
        dataBuffer:{
            documents:[],
            document:null,
            docFiles:[]
        },
        menu2: false,
    },
    actions:{
        setAuthUser({commit},data){
            commit('setAuthUser',data)
        },
        setCurrentUser({commit},data){
            commit('setCurrentUser',data)
        },

        clearData({commit}){
            commit('setAuthUser',null)
            commit('setCurrentUser',null)
        },
        fetchUsers({commit}){
            
            let users = []
            fb.usersCollection.get()
            .then(docs=>{

                docs.forEach(doc=>{
                    const  user = {
                        id:doc.id,
                        userID:doc.data().userID,
                        userName:doc.data().userName,
                        userType:doc.data().userType,
                        email:doc.data().email,
                        brand:doc.data().brand,
                        department:doc.data().department,
                        section:doc.data().section,
                        fileUrl:doc.data().fileUrl,
                        thumbUrl:doc.data().thumbUrl
                    }
                    users.push(user);
                });
                commit('setUsers', users);
                
            })
            .catch(err=>{
                console.log(err)
            })
        },
        fetchCurrentUser({commit,state}){
            
            //console.log("state.authUser.uid",state.authUser.uid);
            fb.usersCollection.where('userID','==',state.authUser.uid).get()
            .then(docs=>{
                //console.log("docs",docs.docs)
                if (docs.docs.length > 0){
                    //console.log("currentUser from fetch",docs.docs[0].data())
                    commit('setCurrentUser',docs.docs[0].data())
                }
                
            })
            .catch(err=>{
                console.log(err)
            })
        },
        updateProfile({state},data){

            let name = data.name
            let title = data.title
            fb.usersCollection.doc(state.currentUser.uid).update({name,title})
            .then(user=>{
                console.log("user updateProfile",user)
            }).catch(err=>{
                console.log(err)
            })
        },
        fetchBrands({commit}){
            let brands = []
            fb.brandsCollection.get()
            .then(docs=>{
                docs.forEach(doc=>{
                    brands.push(doc.data().brand);
                });
                commit('setBrands',brands);
            })
        },
        fetchDepartments({commit}){
            let departments = []
            fb.departmentsCollection.get()
            .then(docs=>{
                docs.forEach(doc=>{
                    departments.push(doc.data().department);
                });
                departments.sort((a,b)=>(a > b) ? 1 : -1);

                commit('setDepartments',departments);
            })
        },
        fetchAssignees({commit}){
            let assignees = []
            fb.assigneesCollection.get()
            .then(docs=>{
                docs.forEach(doc=>{
                    assignees.push({
                        assignee:doc.data().assignee,
                        assigneeID:doc.data().assigneeID,
                        department:doc.data().department
                    });
                });
                commit('setAssignees',assignees);
            })
        },
        fetchIssueMaster({commit}){
            let issueMaster = []
            fb.issueMasterCollection.get()
            .then(docs=>{
                docs.forEach(doc=>{
                    const  issue = {
                        id:doc.id,
                        issue:doc.data().issue,
                        issueType:doc.data().issueType,
                        issueSubtype:doc.data().issueSubtype,
                        idx: doc.data().idx
                    }
                    issueMaster.push(issue);
                });
                issueMaster.sort((a,b)=>(a.issue > b.issue) ? 1 : -1);

                commit('setIssueMaster',issueMaster);
            })
        },

        fetchIssueTypes({commit}){
            let issueTypes = []
            fb.issueTypesCollection.get()
            .then(docs=>{
                docs.forEach(doc=>{
                    issueTypes.push({
                        id:doc.id,
                        issueType:doc.data().issueType
                    });
                });
                issueTypes.sort((a,b)=>(a.issueType > b.issueType) ? 1 : -1);
                commit('setIssueTypes',issueTypes);
            })
        },

        fetchIssueSubtypes({commit}){
            let issueSubtypes = []
            fb.issueSubtypesCollection.get()
            .then(docs=>{
                docs.forEach(doc=>{
                    issueSubtypes.push({
                        id:doc.id,
                        subType:doc.data().subType
                    });
                });
                issueSubtypes.sort((a,b)=>(a.subType > b.subType) ? 1 : -1);
                commit('setIssueSubtypes',issueSubtypes);
            })
        },

        fetchIssues({commit}){
            let issues = [];
            fb.issuesCollection.get()
            .then(colIssues=>{
                //console.log("docs",docs)
                colIssues.forEach(issue=>{
				
                    //console.log("issue",issue.data());
                    if ( issue.data().status != 'Verified Close'){ 

                        const data = {
                            'id':issue.id,
                            'issueID': issue.data().issueID,
                            'issue':issue.data().issue,
                            'issueType':issue.data().issueType,
                            'issueSubtype':issue.data().issueSubtype,
                            'description':issue.data().description,
                            'department':issue.data().department,
                            'location':issue.data().location,
                            'raisedBy':issue.data().raisedBy,
                            'status':issue.data().status,
                            'brand':issue.data().brand,
                            'assignedTo':issue.data().assignedTo,
                            'assignedToID':issue.data().assignedToID,
                            //'assignedDate':issue.data().assignedDate.toDate(),
                            'assignedBy':issue.data().assignedBy,
                            //'commitmentDate':issue.data().commitmentDate.toDate(),
                            'solution':issue.data().solution,
                            'solutionType':issue.data().solutionType,
                            'solutionDesc':issue.data().solutionDesc,
                            'creationDate':issue.data().creationDate.toDate(),
							'dateID':issue.data().dateID
                        }
                        data.assignedDate = issue.data().assignedDate ? issue.data().assignedDate.toDate() : new Date('1/1/0001')
                        data.commitmentDate = issue.data().commitmentDate ? issue.data().commitmentDate.toDate() : new Date('1/1/0001')
                        data.closeDate = issue.data().closeDate ? issue.data().closeDate.toDate() : new Date('1/1/0001')
                        data.location = issue.data().location ?  issue.data().location : ''
                        data.section = issue.data().section ? issue.data().section : ''
                        data.diagnostic = issue.data().diagnostic ? issue.data().diagnostic : ''
                        data.solutionMethod = issue.data().solutionMethod ? issue.data().solutionMethod : ''

                        issues.push(data);
                    }
                });
                
                issues.sort((a,b)=>(a.issueID > b.issueID) ? 1 : -1);
                commit('setIssues',issues);

               //issues.sort((a,b)=>(a.issueID > b.issueID) ? 1 : -1);
                //this.issues = issues;

            })

        },
        fetchIssuesClient({commit,state}){
            let issues = [];
            //console.log("fetch client")
            //console.log("this.state.currentUser.userID",state.currentUser)
            fb.issuesCollection.where('raisedByID','==',state.currentUser.userID).get()
            .then(colIssues=>{
                //console.log("docs",docs)
                colIssues.forEach(issue=>{
				
                    //console.log("issue",issue.data());
                    if ( issue.data().status != 'Verified Close'){ 

                        const data = {
                            'id':issue.id,
                            'issueID': issue.data().issueID,
                            'issue':issue.data().issue,
                            'issueType':issue.data().issueType,
                            'issueSubtype':issue.data().issueSubtype,
                            'description':issue.data().description,
                            'department':issue.data().department,
                            'location':issue.data().location,
                            'raisedBy':issue.data().raisedBy,
                            'status':issue.data().status,
                            'brand':issue.data().brand,
                            'assignedTo':issue.data().assignedTo,
                            'assignedToID':issue.data().assignedToID,
                            //'assignedDate':issue.data().assignedDate.toDate(),
                            'assignedBy':issue.data().assignedBy,
                            'solution':issue.data().solution,
                            'solutionType':issue.data().solutionType,
                            'solutionDesc':issue.data().solutionDesc,
                            'creationDate':issue.data().creationDate.toDate(),
							'dateID':issue.data().dateID
                        }
                        data.assignedDate = issue.data().assignedDate ? issue.data().assignedDate.toDate() : new Date('1/1/0001')
                        data.commitmentDate = issue.data().commitmentDate ? issue.data().commitmentDate.toDate() : new Date('1/1/0001')
                        data.closeDate = issue.data().closeDate ? issue.data().closeDate.toDate() : new Date('1/1/0001')
                        data.location = issue.data().location ?  issue.data().location : ''
                        data.section = issue.data().section ? issue.data().section : ''
                        data.diagnostic = issue.data().diagnostic ? issue.data().diagnostic : ''
                        data.solutionMethod = issue.data().solutionMethod ? issue.data().solutionMethod : ''

                        issues.push(data);
                    }
                });
                
                issues.sort((a,b)=>(a.issueID > b.issueID) ? 1 : -1);
                commit('setIssues',issues);

            })

        },
        fetchIssuesAssignee({commit,state}){
            let issues = [];
            //console.log("fetch assignee")
            //console.log("this.state.currentUser.userID",state.currentUser)
            fb.issuesCollection.where('assignedToID','==',state.currentUser.userID).get()
            .then(colIssues=>{
                //console.log("colIssues",colIssues)
                colIssues.forEach(issue=>{
				
                    //console.log("issue",issue.data());
                    if ( issue.data().status != 'Verified Close'){ 
                        const data = {
                            'id':issue.id,
                            'issueID': issue.data().issueID,
                            'issue':issue.data().issue,
                            'issueType':issue.data().issueType,
                            'issueSubtype':issue.data().issueSubtype,
                            'description':issue.data().description,
                            'department':issue.data().department,
                            'location':issue.data().location,
                            'raisedBy':issue.data().raisedBy,
                            'status':issue.data().status,
                            'brand':issue.data().brand,
                            'assignedTo':issue.data().assignedTo,
                            'assignedToID':issue.data().assignedToID,
                            //'assignedDate':issue.data().assignedDate.toDate(),
                            'assignedBy':issue.data().assignedBy,
                            //'commitmentDate':issue.data().commitmentDate.toDate(),
                            'solution':issue.data().solution,
                            'solutionType':issue.data().solutionType,
                            'solutionDesc':issue.data().solutionDesc,
                            'creationDate':issue.data().creationDate.toDate(),
							'dateID':issue.data().dateID
                        }
                        data.assignedDate = issue.data().assignedDate ? issue.data().assignedDate.toDate() : new Date('1/1/0001')
                        data.commitmentDate = issue.data().commitmentDate ? issue.data().commitmentDate.toDate() : new Date('1/1/0001')
                        data.closeDate = issue.data().closeDate ? issue.data().closeDate.toDate() : new Date('1/1/0001')
                        data.location = issue.data().location ?  issue.data().location : ''
                        data.section = issue.data().section ? issue.data().section : ''
                        data.diagnostic = issue.data().diagnostic ? issue.data().diagnostic : ''
                        data.solutionMethod = issue.data().solutionMethod ? issue.data().solutionMethod : ''
                        issues.push(data);
                    }
                });
                
                issues.sort((a,b)=>(a.issueID > b.issueID) ? 1 : -1);
                commit('setIssues',issues);

            })

        },

        fetchSolutions({commit}){
            let solutions = []
            fb.solutionsCollection.get()
            .then(docs=>{
                docs.forEach(doc=>{
                    const  solution = {
                        id:doc.id,
                        solution:doc.data().solution,
                        solutionType:doc.data().solutionType,
                        idx: doc.data().idx
                    }
                    solutions.push(solution);
                });
                solutions.sort((a,b)=>(a.solution > b.solution) ? 1 : -1);
                commit('setSolutions',solutions);
            })
            
        },
        fetchSolutionTypes({commit}){

            let solutionTypes = []
            fb.solutionTypesCollection.get()
            .then(docs=>{
                docs.forEach(doc=>{
                    solutionTypes.push({
                        id:doc.id,
                        solutionType:doc.data().solutionType
                    });
                });
                solutionTypes.sort((a,b)=>(a.solutionType > b.solutionType) ? 1 : -1);
                commit('setSolutionTypes',solutionTypes);
            })
        },
        fetchSolutionMethods({commit}){

            let solutionMethods = []
            fb.solutionMethodsCollection.get()
            .then(docs=>{
                docs.forEach(doc=>{
                    solutionMethods.push(doc.data().method);
                });
                solutionMethods.sort((a,b)=>(a > b) ? 1 : -1);
                commit('setSolutionMethods',solutionMethods);
            })
        },
        fetchSections({commit}){

            let sections = []
            fb.sectionsCollection.get()
            .then(docs=>{
                docs.forEach(doc=>{
                    sections.push(doc.data().section);
                });
                sections.sort((a,b)=>(a > b) ? 1 : -1);
                commit('setSections',sections);
            })
        },
        fetchLocations({commit}){

            let locations = []
            fb.locationsCollection.get()
            .then(docs=>{
                docs.forEach(doc=>{
                    locations.push({
                        id:doc.id,
                        location:doc.data().location
                    });
                });
                locations.sort((a,b)=>(a.location > b.location) ? 1 : -1);

                commit('setLocations',locations);
            })
        },
        fetchDiagnostics({commit}){
            let diagnostics = []
            fb.diagnosticsCollection.get()
            .then(docs=>{
                docs.forEach(doc=>{
                    const  diagnostic = {
                        diagnostic:doc.data().diagnostic,
                        diagnosticType: doc.data().diagnosticType
                    }
                    diagnostic.idx =  doc.data().idx ? doc.data().idx : '1'
                    diagnostic.creationDate = doc.data().creationDate ? doc.data().creationDate : new Date()
                    diagnostics.push(diagnostic);
                });
                diagnostics.sort((a,b)=>(a.diagnostic > b.diagnostic) ? 1 : -1);
                commit('setDiagnostics',diagnostics);
            })
            
        },
        fetchDiagnosticTypes({commit}){

            let diagnosticTypes = []
            fb.diagnosticTypesCollection.get()
            .then(docs=>{
                docs.forEach(doc=>{
                    diagnosticTypes.push({
                        id: doc.id,
                        diagnosticType: doc.data().diagnosticType
                    });
                });
                diagnosticTypes.sort((a,b)=>(a.diagnosticType > b.diagnosticType) ? 1 : -1);
                commit('setDiagnosticTypes',diagnosticTypes);
            })
        },


    },
    mutations:{
        setUsers(state,val){
            state.users = val
            //console.log("state.users",state.users)
        },
        setAuthUser(state,val){
            state.authUser = val;
            //console.log("state.authUser",state.authUser)
        },
        setCurrentUser(state,val){
            state.currentUser = val
            localStorage.setItem('currentUser',JSON.stringify(state.currentUser))
            //console.log("state.currentUser",state.currentUser)
        },
        setUserProfile(state,val){
            state.userProfile = val
            //console.log("state.userProfile",state.userProfile)
        },
        setIssues(state,val){
            state.issues = val;
            //console.log("state.issues",state.issues)
        },
        setBrands(state,val){
            state.brands = val;
            //console.log("state.brands",state.brands)
        },
        setDepartments(state,val){
            state.departments = val;
            //console.log("state.departments",state.departments)
        },
        setAssignees(state,val){
            state.assignees = val;
            //console.log("state.assignees",state.assignees)
        },
        setIssueMaster(state,val){
            state.issueMaster  = val;
            //console.log("state.issueMaster",state.issueMaster);
        },
        setIssueTypes(state,val){
            state.issueTypes  = val;
            //console.log("state.issueTypes",state.issueTypes);
        },
        setIssueSubtypes(state,val){
            state.issueSubtypes  = val;
            //console.log("state.issueSubtypes",state.issueSubtypes);

        },
        setSolutions(state,val){
            state.solutions = val;
           //console.log("state.solutions",state.solutions)
        },
        setSolutionTypes(state,val){
            state.solutionTypes = val;
           //console.log("state.solutionTypes",state.solutionTypes)
        },
        setSolutionMethods(state,val){
            state.solutionMethods =  val
        },
        setSections(state,val){
            state.sections = val
        },
        setDiagnostics(state,val){
            state.diagnostics = val
        },
        setDiagnosticTypes(state,val){
            state.diagnosticTypes = val
        },
        setLocations(state,val){
            state.locations = val
            //console.log("state.locations",state.locations)
        }

    }
})
